<div class="tab-divider"></div>

<div class="top-div">
  <div class="container-div">
    <div class="container d-flex flex-column">
        <div class="d-flex flex-row">
          <span class="col-md-10 general-text-5">Coverage w.r.t Requirement Document</span
          ><span class="col-md-2 header-8">{{ mappingOverview.coverage?.coverage1 }}%</span>
        </div>
        <div class="d-flex flex-row">
            <span class="col-md-10 general-text-5">Coverage w.r.t Requirement Document</span
            ><span class="col-md-2 header-8">{{ mappingOverview.coverage?.coverage2 }}%</span>
          </div>
      </div>
  </div>

  <app-accordion [accordionData]="mappingOverview.data"></app-accordion>
</div>
